var styles = {"box":"TableTd_box_n2ojb_1","win":"TableTd_win_n2ojb_14","loose":"TableTd_loose_n2ojb_18"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
